const CryptoJS = require("crypto-js");
const aesKey = "LjG2S3CDSYAoiFEx4Sk8bBPme88AUeZ1"; // 密钥，要和后端一致
export default {
    decode(iv, data) {
        let keyStr = CryptoJS.enc.Utf8.parse(aesKey); // 密钥
        let ivStr = CryptoJS.enc.Utf8.parse(iv);  // 初始化向量
        // 使用AES解密
        const decrypted = CryptoJS.AES.decrypt(data, keyStr, {
            iv: ivStr,
            mode: CryptoJS.mode.CBC,
            padding: CryptoJS.pad.Pkcs7
        });
        return decrypted.toString(CryptoJS.enc.Utf8);
    },
    decode2(aesKey, iv, data) {
        let keyStr = CryptoJS.enc.Utf8.parse(aesKey); // 密钥
        let ivStr = CryptoJS.enc.Utf8.parse(iv);  // 初始化向量
        // 使用AES解密
        const decrypted = CryptoJS.AES.decrypt(data, keyStr, {
            iv: ivStr,
            mode: CryptoJS.mode.CBC,
            padding: CryptoJS.pad.Pkcs7
        })
        return decrypted.toString(CryptoJS.enc.Utf8);
    },
    encode(iv, data) {
        let keyStr = CryptoJS.enc.Utf8.parse(aesKey); // 密钥
        let ivStr = CryptoJS.enc.Utf8.parse(iv);  // 初始化向量
        // 使用AES加密
        const encrypted = CryptoJS.AES.encrypt(data, keyStr, {
            iv: ivStr,
            mode: CryptoJS.mode.CBC,
            padding: CryptoJS.pad.Pkcs7
        });
        // 输出加密结果，通常为Base64编码的字符串
        return encrypted.toString();
    },
    encode2(aesKey, iv, data) {
        let keyStr = CryptoJS.enc.Utf8.parse(aesKey); // 密钥
        let ivStr = CryptoJS.enc.Utf8.parse(iv);  // 初始化向量
        // 使用AES加密
        const encrypted = CryptoJS.AES.encrypt(data, keyStr, {
            iv: ivStr,
            mode: CryptoJS.mode.CBC,
            padding: CryptoJS.pad.Pkcs7
        });
        // 输出加密结果，通常为Base64编码的字符串
        return encrypted.toString();
    }
}